import axiosInstance from "./axios";

export const getDashboardStats = async () => {
    const response = await axiosInstance.get("/dashboard-stats");
    return response.data;
};

// PUT /update-battle  → body: { isBattle: true | false }
export const updateBattleStatus = async (isBattle) => {
    const response = await axiosInstance.put("/update-battle", { isBattle });
    return response.data;
};